import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  heroStats, divisions, missionVision, services, offerings,
  ayurvedaProducts, whyChoose, industries, contactInfo,
} from '../mock';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback content composed from mock data (used if API is unavailable)
export const fallbackContent = {
  nav: [
    { label: 'Home', href: '#home' },
    { label: 'IT Services', href: '#services' },
    { label: 'Electronics', href: '#electronics' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ],
  hero: {
    badge: 'Welcome to Vetrich Technologies',
    title: 'One Group, Two Powerful Divisions',
    subtitle:
      'A trusted provider of IT & eTender consultancy and our own brand of quality electronics — all under one accountable group.',
    image: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=85&w=1600&auto=format&fit=crop',
    stats: heroStats,
  },
  divisions,
  whoweare: {
    heading: 'Simplifying business & digital, together.',
    paragraph:
      'VETRICH TECHNOLOGIES helps businesses, contractors, startups and organizations simplify government procedures and accelerate digital transformation through reliable, professional and technology-driven services. Our experienced team ensures every client receives accurate guidance, timely support and complete assistance — from registration to successful project completion.',
    mission: { title: missionVision[0].title, desc: missionVision[0].desc },
    vision: { title: missionVision[1].title, desc: missionVision[1].desc },
  },
  services,
  offerings,
  ayurveda: {
    heading: 'Our wellness range',
    subtitle: 'Explore our authentic Ayurvedic formulations crafted for everyday wellness.',
    products: ayurvedaProducts,
  },
  whyChoose,
  industries,
  electronics: {
    heading: 'Vetrich Electronics',
    subtitle: 'Our own brand of premium consumer electronics is launching soon.',
    coming_soon: true,
    products: [
      { name: 'Vetrich Buds', image: '/electronics/buds.jpg' },
      { name: 'Vetrich Neck Band', image: '/electronics/neckband.jpg' },
      { name: 'Vetrich Power Bank', image: '/electronics/powerbank.jpg' },
      { name: 'Vetrich Adapter', image: '/electronics/adapter.jpg' },
      { name: 'Vetrich Trolley Speaker', image: '/electronics/trolley.jpg' },
      { name: 'Vetrich Home Theater', image: '/electronics/hometheater.jpg' },
      { name: 'Vetrich Bluetooth Speaker', image: '/electronics/btspeaker.jpg' },
      { name: 'Vetrich Soundbar', image: '/electronics/soundbar.jpg' },
      { name: 'Vetrich Tower Speaker', image: '/electronics/tower.jpg' },
    ],
  },
  contact: contactInfo,
};

export function useContent() {
  const [content, setContent] = useState(fallbackContent);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/content`);
        if (active && data && data.hero) setContent(data);
      } catch (e) {
        // keep fallback
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return { content, loading };
}
